"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientNumber = void 0;
const typeorm_1 = require("typeorm");
const class_transformer_1 = require("class-transformer");
const JournaledEntity_1 = require("../../JournaledEntity");
// eslint-disable-next-line import/no-cycle
const Client_1 = require("./Client");
const CircularReference_1 = require("../../serialization/CircularReference");
let ClientNumber = class ClientNumber extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.ClientNumber = ClientNumber;
__decorate([
    (0, typeorm_1.OneToOne)(() => Client_1.Client, (c) => c.clientNumber),
    (0, typeorm_1.JoinColumn)(),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Client_1.Client)
], ClientNumber.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.RelationId)((cn) => cn.client),
    __metadata("design:type", String)
], ClientNumber.prototype, "clientId", void 0);
__decorate([
    (0, typeorm_1.Column)({ unique: true }),
    __metadata("design:type", String)
], ClientNumber.prototype, "number", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'date' }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], ClientNumber.prototype, "referenceDate", void 0);
exports.ClientNumber = ClientNumber = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Unique)(['client']),
    (0, typeorm_1.Unique)(['number']),
    __metadata("design:paramtypes", [Object])
], ClientNumber);
